import getTranslation from 'bdata-sns-shared/utils/getTranslation';
import GameStateTypes from 'bdata-sns-shared/game/types/GameStateTypes';
import getProcessedGameDate from 'bdata-sns-shared/utils/getProcessedGameDate';

export const getGameStateBaseLabel = (options) => {
    const {
        gameState,
        dictionary,
        currentInning,
        scheduledInnings,
        inningState,
        gameDate,
        tz,
        isPreview,
        startTimeTBD,
        game,
        isDoubleHeader,
        isMiniSB,
        isMIG,
        isSuspendedResumptionOnDate,
        localTimezone
    } = options;

    const displayState = isSuspendedResumptionOnDate ? GameStateTypes.PREVIEW : gameState;

    let content = '';
    switch (displayState) {
    case GameStateTypes.PREVIEW:
        content = getProcessedGameDate({
            gameDate,
            tz,
            isPreview,
            startTimeTBD,
            game,
            dictionary,
            isDoubleHeader,
            isMiniSB,
            isMIG,
            localTimezone
        });
        return content;
    case GameStateTypes.LIVE:
        if (inningState) {
            content =  `${getTranslation(dictionary, inningState, inningState)} ${currentInning}`;
        }
        return content;
    case GameStateTypes.FINAL:
        const extraInningsSuffix = (typeof currentInning !== 'undefined' && typeof scheduledInnings !== 'undefined' && currentInning !== scheduledInnings) ? `/${currentInning}` : '';
        content = `${getTranslation(dictionary, 'game_status_final', 'Final')}${extraInningsSuffix}`;
        return content;
    default:
        return content;
    }
};
